import { Box, Theme, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import {
  OperationCompanyOrderTypeOption,
  OrderEntryQueryParams,
  RootState,
  selectAllCustomerOrderTypeOptions,
  useAppSelector,
} from 'common';
import { FC, useEffect, useState } from 'react';
import { CfSelect, SelectItem } from '../../../../../cf-ui/Select/CfSelect';
import { CfTextFieldPropSizes } from '../../../../../cf-ui/TextField/CfTextField';
import { useQueryParams } from '../../../../../hooks/useQueryParams';

export type OrderTypeSelectProps = {
  operationCompanyOrderTypeId: string;
  onChange: (option: OperationCompanyOrderTypeOption) => void;
  sx?: SxProps<Theme>;
  size?: CfTextFieldPropSizes;
};

export const OrderTypeSelect: FC<OrderTypeSelectProps> = (props: OrderTypeSelectProps) => {
  const queryParams = useQueryParams<OrderEntryQueryParams>();

  const options = useAppSelector((s: RootState) =>
    selectAllCustomerOrderTypeOptions(s.customer.operationCompanyOrderTypes)
  );

  const [selectedOption, setSelectedOption] = useState(
    options?.filter?.((o) => o.OperationCompanyOrderTypeId === props.operationCompanyOrderTypeId)?.[0]
  );

  useEffect(() => {
    setSelectedOption(
      options?.filter?.((o) => o.OperationCompanyOrderTypeId === props.operationCompanyOrderTypeId)?.[0]
    );
  }, [props.operationCompanyOrderTypeId, options]);

  const handleSelect = (selectItem: SelectItem<OperationCompanyOrderTypeOption>): void => {
    setSelectedOption(selectItem.item);
    props.onChange(selectItem.item);
  };

  const getSelectOption = (option: OperationCompanyOrderTypeOption): SelectItem<OperationCompanyOrderTypeOption> => {
    return {
      value: option.OrderTypeName,
      label: (
        <Typography sx={{ typography: { xs: 'mobileParagraph', xl: 'paragraph' } }}>{option.OrderTypeName}</Typography>
      ),
      item: option,
    } as SelectItem<OperationCompanyOrderTypeOption>;
  };

  const selectOptions = options.map(getSelectOption);

  return (
    <Box sx={{ ...props.sx }}>
      <CfSelect
        isLoading={selectOptions.length < 1}
        items={selectOptions}
        inputProps={{
          inlineLabel: 'Type:',
          value: selectedOption?.OrderTypeName ?? '',
        }}
        onSelect={handleSelect}
      />
    </Box>
  );
};
